import Util from "@/Master/Util";
import IndexedDB from "@/Fwk/IndexDB/IndexedDB";
import Encrypt from "@/Fwk/Encrypt/Encrypt";
import AESHelper from "@/Fwk/Encrypt/AESHelper";

interface ItemData {
    id: string;
    value: string;
}

export default class DBMgr {
    static tag = '[DB-DBMgr]';
    static dbName: string = 'UnityDB';
    static dbVersion: number = 1;
    static dbManager: IndexedDB | null = null;
    static allData: ItemData[] = [];
    static mapData: Map<string, string> = new Map();
    private static isInit: boolean;

    static Init(callback: () => void): void {
        if (this.isInit) return;
        this.isInit = true;
        this.dbName = 'GameDB';
        this.dbVersion = 1;
        if (Util.isLog){
            // console.group('初始化数据库');
        }
        this.dbManager = new IndexedDB(this.dbName, this.dbVersion, (allData: ItemData[]) => {
            this.setAllData(allData);
            callback();

        });
    }

    // 对键加密
    static encryptKey(key: string): string {
        return AESHelper.EncryptWeb(key, Encrypt.getSecretKey);
    }

    // 对键解密
    static decryptKey(encryptedKey: string): string {
        return AESHelper.DecryptWeb(encryptedKey, Encrypt.getSecretKey);
    }

    static setAllData(allData: ItemData[]): void {
        this.allData = allData;
        this.mapData.clear();
        for (let i = 0; i < allData.length; i++) {
            const item = allData[i];
            const decryptedKey = this.decryptKey(item.id); // 解密键
            this.mapData.set(decryptedKey, item.value);
        }
        if (Util.isLog) {
            console.log(this.tag, '更新临时所有数据成功', allData);
        }
    }

    // 列出所有数据
    static getAllData(): void {
        if (!this.dbManager) return;
        this.dbManager.getAllData().then((allData: ItemData[]) => {
            this.setAllData(allData);
        });
    }

    // 更新DB数据
    static UpdateData(id: string, valueStr: string): void {
        if (!this.dbManager) return;

        const encryptedKey = this.encryptKey(id); // 加密键
        const encryptedValue: string = AESHelper.EncryptWeb(valueStr, Encrypt.getSecretKey); // 加密值
        this.mapData.set(id, encryptedValue);
        this.dbManager.updateData({id: encryptedKey, value: encryptedValue});
    }

    // 获取当前数据的内存数据
    static GetData(id: string): string {
        try {
            if (this.mapData.has(id)) {
                const encryptedStr = this.mapData.get(id) || '';
                const valueStr = AESHelper.DecryptWeb(encryptedStr, Encrypt.getSecretKey); // 解密值
                return valueStr;
            } else {
                return '';
            }
        } catch (error) {
            return '';
        }
    }

    static delData(id: string): void {
        if (!this.dbManager) return;

        const encryptedKey = this.encryptKey(id); // 加密键
        this.dbManager.deleteData(encryptedKey).then(() => {
            this.mapData.delete(id);
        });
    }

    static clearAllData(): void {
        if (!this.dbManager) return;
        this.dbManager.clearAllData();
        this.mapData.clear();
    }

}
